// extracted by mini-css-extract-plugin
export var avoid = "SupportSection-module--avoid--T4aj5";
export var columns = "SupportSection-module--columns--Z7XG9";
export var header = "SupportSection-module--header--a7cMW";
export var img = "SupportSection-module--img--Orl1w";
export var subtitle = "SupportSection-module--subtitle--rfYaJ";